import { AnswerOption } from "@/api/generated-catch-backend/model";
export interface SelectOptionProps {
  option: AnswerOption;
  value: string;
  handleChange: (newValue: string, isSelected?: boolean) => void;
}

export const SelectOption = ({ option, value, handleChange }: SelectOptionProps) => {
  if (option.imageUrl || option.hexColor) {
    return (
      <button
        key={option.slug}
        type="button"
        onClick={() => handleChange(option.slug)}
        aria-label={`Select ${option.displayText}`}
        className={`select-option-base ${value === option.slug ? 'select-option-selected' : 'select-option-unselected'}`}
      >
        <div className="flex w-full flex-row items-center gap-[15px]">
          <div
            className="border border-catch-dark-blue-90-30 flex h-10 w-[49px] shrink-0 items-center justify-center overflow-hidden rounded-[5px]"
            style={option.hexColor ? { backgroundColor: option.hexColor } : undefined}
          >
            {option.imageUrl && (
              <img src={option.imageUrl} alt={option.displayText} className="h-full w-full object-cover" />
            )}
          </div>
          <span
            className={`select-option-text text-left ${value === option.slug ? 'select-option-text-selected' : 'select-option-text-unselected'}`}
          >
            {option.displayText}
          </span>
        </div>
      </button>
    );
  } else {
    return (
      <button
        type="button"
        key={option.slug}
        onClick={() => handleChange(option.slug)}
        aria-label={`Select ${option.displayText}`}
        className={`select-option-base ${
          value === option.slug ? 'select-option-selected' : 'select-option-unselected'
        }`}
      >
        <span
          className={`select-option-text text-center ${value === option.slug ? 'select-option-text-selected' : 'select-option-text-unselected'}`}
        >
          {option.displayText}
        </span>
      </button>
    );
  }
};
